function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { XIcon } from 'lucide-react';
import * as React from 'react';
import { usePortalContainer } from '../../lib/portal-container-context';
import { cn } from '../../lib/utils';
function Dialog(_0) {
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsx(DialogPrimitive.Root, _object_spread({
        "data-slot": "dialog"
    }, props));
}
function DialogTrigger(_0) {
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsx(DialogPrimitive.Trigger, _object_spread({
        "data-slot": "dialog-trigger"
    }, props));
}
function DialogPortal(_0) {
    let {} = _0, props = _extends({}, _0);
    const portalContainer = usePortalContainer();
    return /*#__PURE__*/ _jsx(DialogPrimitive.Portal, _object_spread({
        container: portalContainer !== null && portalContainer !== void 0 ? portalContainer : undefined,
        "data-slot": "dialog-portal"
    }, props));
}
function DialogClose(_0) {
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsx(DialogPrimitive.Close, _object_spread({
        "data-slot": "dialog-close"
    }, props));
}
const DialogOverlay = /*#__PURE__*/ React.forwardRef((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { className } = _ref1, props = _object_without_properties(_ref1, [
        "className"
    ]), [ref] = _rest;
    return /*#__PURE__*/ _jsx(DialogPrimitive.Overlay, _object_spread({
        ref: ref,
        "data-slot": "dialog-overlay",
        className: cn('data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50', className)
    }, props));
});
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;
function DialogContent(_0) {
    let { className, children, showCloseButton = true } = _0, props = _object_without_properties(_0, [
        "className",
        "children",
        "showCloseButton"
    ]);
    return /*#__PURE__*/ _jsxs(DialogPortal, {
        "data-slot": "dialog-portal",
        children: [
            /*#__PURE__*/ _jsx(DialogOverlay, {}),
            /*#__PURE__*/ _jsxs(DialogPrimitive.Content, _object_spread_props(_object_spread({
                "data-slot": "dialog-content",
                className: cn('bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg', className)
            }, props), {
                children: [
                    children,
                    showCloseButton && /*#__PURE__*/ _jsxs(DialogPrimitive.Close, {
                        "data-slot": "dialog-close",
                        className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none cursor-pointer [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
                        children: [
                            /*#__PURE__*/ _jsx(XIcon, {}),
                            /*#__PURE__*/ _jsx("span", {
                                className: "sr-only",
                                children: "Close"
                            })
                        ]
                    })
                ]
            }))
        ]
    });
}
function DialogHeader(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread({
        "data-slot": "dialog-header",
        className: cn('flex flex-col gap-2 text-center sm:text-left', className)
    }, props));
}
function DialogFooter(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread({
        "data-slot": "dialog-footer",
        className: cn('flex flex-col-reverse gap-2 sm:flex-row sm:justify-end', className)
    }, props));
}
function DialogTitle(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(DialogPrimitive.Title, _object_spread({
        "data-slot": "dialog-title",
        className: cn('text-lg leading-none font-semibold', className)
    }, props));
}
function DialogDescription(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(DialogPrimitive.Description, _object_spread({
        "data-slot": "dialog-description",
        className: cn('text-muted-foreground text-sm', className)
    }, props));
}
export { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger };
